// extracted by mini-css-extract-plugin
export default {"chip":"AgeGroupChip_chip__ZkzyJ","glyph":"AgeGroupChip_glyph__5woqF","chipKid":"AgeGroupChip_chipKid__-q3RN","chipBoth":"AgeGroupChip_chipBoth__7EM+4"};